import React from "react";
import ExpensesModule from "../../finance/expenses/ExpensesModule";

/* Staff expenses view — thin wrapper around the main-workspace
   ExpensesModule, scoped to the current user's own expenses.

   selfView (see ExpensesModule): filters expenses to createdBy === user.id,
   hides the one-off/recurring tab switcher (staff don't manage recurring),
   hides cross-user analytics (monthly trend, by-category donut, by-
   location bar, spending-intelligence AI panel), and disables edit / delete
   / approve actions on submitted items. The "Log Expense" FAB + modal stay
   available so staff can still submit new expenses for approval. */
export default function ExpensesPanel({state,dispatch,t,platformCtx,user}){
  return(
    <ExpensesModule
      state={state}
      dispatch={dispatch}
      t={t}
      platformCtx={platformCtx}
      currentUser={user}
      defaultUser={user.id}
      selfView={user.id}
    />
  );
}
